/**
 * CSV Export Button component.
 * Triggers a CSV file download when clicked.
 *
 * @module csv-export-button
 */

/**
 * Creates a CSV export button that downloads the provided CSV string as a file.
 *
 * @param {Object} config
 * @param {string} config.label - Button text (default "Export CSV")
 * @param {Function} config.getCsvContent - Function returning the CSV string to download
 * @param {string} config.filename - Download filename (default "export.csv")
 * @returns {HTMLButtonElement}
 */
export function createCsvExportButton({ label = 'Export CSV', getCsvContent, filename = 'export.csv' } = {}) {
  const btn = document.createElement('button');
  btn.className = 'btn btn--secondary csv-export-button';
  btn.textContent = label;

  btn.addEventListener('click', () => {
    const csv = getCsvContent();
    if (!csv) return;

    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    link.style.display = 'none';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  });

  return btn;
}
